import FrameShell from './FrameShell';

/* The real LinksOS tee sheet, recreated from the live portal. Sample data. */

const KPIS = [
  ['76', 'Times open'],
  ['95/304', 'Seats booked'],
  ['31%', 'Fill rate'],
  ['$4,610', 'Booked value'],
];

const ROWS = [
  ['07:00 AM', 2, 'App booking', '$52'],
  ['07:08 AM', 3, 'App booking', '$52'],
  ['07:16 AM', 1, 'Walk-in', '$52'],
  ['07:24 AM', 2, 'App booking', '$52'],
];

export default function TeeSheetFrame() {
  return (
    <FrameShell caption="LinksOS · the tee sheet · sample data">
      <div style={{ padding: '16px 18px 18px' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap', marginBottom: 12 }}>
          <span style={{ fontSize: '1.15rem', fontWeight: 750, letterSpacing: '-0.02em' }}>Tee Sheet</span>
          <span style={{ fontSize: 10.5, color: 'var(--mut)' }}>MGL Demo Course · Friday, August 7</span>
          <span className="mono" style={{ marginLeft: 'auto', fontSize: 9, fontWeight: 600, border: '1px solid var(--line)', borderRadius: 6, padding: '4px 9px', color: 'var(--mut)' }}>
            Open register
          </span>
        </div>

        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', background: 'var(--card)', border: '1px solid var(--line-soft)', borderRadius: 8, padding: '7px 10px', marginBottom: 12 }}>
          <span style={{ fontSize: 9.5, fontWeight: 700 }}>Tee-sheet engine</span>
          {['76 live times', 'Live with the golfer app'].map((c) => (
            <span key={c} className="mono" style={{ fontSize: 8.5, fontWeight: 600, background: 'rgba(47,107,76,0.12)', color: 'var(--fairway)', borderRadius: 10, padding: '2px 8px' }}>
              {c}
            </span>
          ))}
          <span style={{ fontSize: 8.5, color: 'var(--faint)' }}>Transparent demand pricing, capped at 25 percent</span>
        </div>

        <div className="tsf-kpis">
          {KPIS.map(([big, label]) => (
            <div key={label} style={{ background: 'var(--card)', border: '1px solid var(--line-soft)', borderRadius: 9, padding: '8px 10px', textAlign: 'center' }}>
              <div className="mono" style={{ fontSize: '0.98rem', fontWeight: 600 }}>{big}</div>
              <div style={{ fontSize: 8.5, color: 'var(--faint)' }}>{label}</div>
            </div>
          ))}
        </div>

        <div className="tsf-row on-pine" style={{ background: 'var(--pine-deep)', color: 'var(--cream)', borderRadius: '8px 8px 0 0', padding: '7px 12px' }}>
          {['TIME', 'PLAYERS', 'PRICE', 'STATUS'].map((h) => (
            <span key={h} className="mono" style={{ fontSize: 8, letterSpacing: '0.12em', color: 'var(--cream-mut)' }}>{h}</span>
          ))}
        </div>
        <div style={{ border: '1px solid var(--line-soft)', borderTop: 'none', borderRadius: '0 0 8px 8px', overflow: 'hidden' }}>
          {ROWS.map(([time, booked, source, price], i) => (
            <div key={time} className="tsf-row" style={{ padding: '7px 12px', background: i % 2 ? 'var(--card)' : 'var(--paper)' }}>
              <span className="mono" style={{ fontSize: 10, fontWeight: 600 }}>{time}</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
                {Array.from({ length: 4 }).map((_, j) => (
                  <span
                    key={j}
                    style={{
                      width: 19, height: 19, borderRadius: '50%', flexShrink: 0,
                      background: j < booked ? 'var(--pine)' : 'transparent',
                      border: j < booked ? 'none' : '1.5px dashed rgba(31,46,38,0.25)',
                    }}
                  />
                ))}
                <span style={{ fontSize: 9, color: 'var(--mut)', marginLeft: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {booked} of 4 · {source}
                </span>
              </span>
              <span className="mono" style={{ fontSize: 10, fontWeight: 600 }}>{price}</span>
              <span className="mono" style={{ fontSize: 8, fontWeight: 600, background: 'rgba(47,107,76,0.12)', color: 'var(--fairway)', borderRadius: 9, padding: '2px 0', textAlign: 'center' }}>
                Open
              </span>
            </div>
          ))}
        </div>
      </div>
    </FrameShell>
  );
}
